import React, { useRef, useEffect, useState, useCallback } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { clear } from "../../../../modules/asset";

const HorizontalInfinity = (props) => {
    const { children, next, scrollableTarget, count, ...rest } = props;
    let throttleHandler = false;
    const targetComponent = useRef();

    useEffect(() => {
        const targetDom = targetComponent && targetComponent.current && targetComponent.current._infScroll;
        // targetDom.addEventListener("scroll", handleScroll);
        return () => {
            const targetDom = targetComponent && targetComponent.current && targetComponent.current._infScroll;
            // targetDom.removeEventListener("scroll", handleScroll);
        };
    }, []);

    // const handleScroll = (e) => {
    //     const targetDom = targetComponent && targetComponent.current && targetComponent.current._infScroll;
    //     const scrollLeft = targetDom.scrollLeft;
    //     const { bottom, height, left, right, top, width, x, y } = targetDom.getBoundingClientRect();
    //     const scrollWidth = targetDom.scrollWidth;
    //     const percent = 0.9;
    //     if ((scrollWidth - width) * percent <= scrollLeft) {
    //         if(!throttleHandler){
    //             throttleHandler = setTimeout(()=>{
    //                 // console.log("right end");
    //                 next();
    //                 throttleHandler = false;
    //             }, 500)        
    //         }
    //     }
    // };

    const handleOnScroll = (e) => {
        const targetDom = e.target;
        // const targetDom = targetComponent && targetComponent.current && targetComponent.current._infScroll.parentNode;
        const scrollLeft = targetDom.scrollLeft;
        const { bottom, height, left, right, top, width, x, y } = targetDom.getBoundingClientRect();
        const scrollWidth = targetDom.scrollWidth;
        // console.log('scroll', e)
        // console.log('targetDom', targetDom)
        // console.log("targetScrollLeft", scrollLeft);
        // console.log("width", width);
        // console.log("scrollWidth", scrollWidth);
        const percent = 0.9;
        if ((scrollWidth - width) * percent <= scrollLeft) {
            if(!throttleHandler){
                throttleHandler = setTimeout(()=>{
                    console.log("right end");
                    next();
                    throttleHandler = false;
                }, 500)
                
            }
        }
    };

    return (
        <InfiniteScroll 
            {...rest} 
            onScroll={handleOnScroll} 
            scrollableTarget={scrollableTarget}
            ref={targetComponent}
        >
            {children}
        </InfiniteScroll>
    );
};

export default HorizontalInfinity;
